<template>
  <a-modal
    title="合并索引"
    :width="'500px'"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <div class="row title">
      请选择一条数据作为合并后的主索引。
    </div>
    <a-radio-group v-model="form.empi">
      <div v-for="(item, key) in data" :key="key" class="row">
        <a-radio :value="item.empi">{{item.empi +'-'+ item.name }}</a-radio>
      </div>
    </a-radio-group>
  </a-modal>
</template>

<script>
  import { postAction } from '@/api/manage'

  export default {
    name: 'EmpiMergeModel',
    data(){
      return {
        confirmLoading:false,
        visible:false,
        data:[],
        form:{
          data:[],
          empi:'',
        }
      }
    },
    methods:{
      handleOk(){
        const dataKey = []
        this.data.forEach(item=>{
          dataKey.push(item.empi)
        })
        this.form.data = dataKey
        if(!this.form.empi){
          return this.$message.warning('请选择一条数据！')
        }
        postAction("/management/empi/merge",this.form).then(res=>{
          if(res.success){
            this.handleCancel()
            this.$emit('ok')
          }
        })
      },
      open(selectRows){
        if(!selectRows || selectRows.length<2 ){
          return this.$message.warning('请选择至少2条数据进行合并！')
        }
        this.data = JSON.parse(JSON.stringify(selectRows))
        this.form = {
          data:[],
          empi:'',
        }
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      }
    }
  }
</script>

<style scoped lang="less">
  .row{
    margin-bottom: 10px;
  }
  .title{
    font-size: 18px;
    color: @primary-color;
    margin-bottom: 20px;
  }
</style>